module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "featured background-purple",
    attrs: {
      "id": "mission"
    }
  }, [_vm._m(0), _vm._v(" "), _c('article', {
    staticClass: "container padding-top__none"
  }, [_c('p', [_vm._v("I prefer to work in a collaborative environment with a team that shares a purpose. My career has always\n        centered around empowering people, even as I pursued a masters degree and career in tech. I believe it is possible to obtain both by pursuing a career in accessibility.")]), _vm._v(" "), _c('blockquote', [_vm._v("By putting accessibility first, we not only produce better code, but find a purpose for doing so.")]), _vm._v(" "), _c('p', [_vm._v("My mission is to join with others who want more out of a career. I partner with people who combine corporate priorities\n    with the people that support them, who seek to empower users of all abilities, and who choose compassion over competition. If you are looking for someone like me, "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 4000
      }),
      expression: "{ duration: 4000}"
    }],
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("I'd love to chat.")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "projects"
    }
  }, [_vm._m(1), _vm._v(" "), _c('project-items', {
    attrs: {
      "projects": _vm.projects
    }
  })], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "container global_title--section-main"
  }, [_c('h3', {
    staticClass: "anchor global_subtitle upper",
    attrs: {
      "data-anchor-id": "mission"
    }
  }, [_vm._v("Mission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-indigo"
  }, [_c('header', {
    staticClass: "container global_title--section-main"
  }, [_c('h3', {
    staticClass: "anchor upper global_subtitle soft-gray",
    attrs: {
      "data-anchor-id": "projects"
    }
  }, [_vm._v("Recent Projects")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "background-purple"
  }, [_c('header', {
    staticClass: "container global_title--section-main"
  }, [_c('h3', {
    staticClass: "anchor global_subtitle upper",
    attrs: {
      "data-anchor-id": "contact"
    }
  }, [_vm._v("Get In Touch")])]), _vm._v(" "), _c('article', {
    staticClass: "container padding-top__none"
  }, [_c('ul', {
    staticClass: "contact_links"
  }, [_c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://github.com/lesliedoherty",
      "target": "_blank"
    }
  }, [_vm._v("\n            Github "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("link takes you to new page.")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://www.linkedin.com/in/leslied/",
      "target": "_blank"
    }
  }, [_vm._v("\n            LinkedIn "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(" link takes you to a new page.")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://twitter.com/mrsflinger",
      "target": "_blank"
    }
  }, [_vm._v("\n            Twitter "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(" link takes you to a new page with the twitter profile for @mrsflinger.")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "contact_links--item",
    attrs: {
      "href": "https://instagram.com/mrsflinger",
      "target": "_blank"
    }
  }, [_vm._v("\n            Instagram "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Link takes you to a new page.")])])])]), _vm._v(" "), _c('p', [_vm._v("I'll be incorporating a static contact form here shortly. For now, I apologize for the links to reach me elsewhere.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8852657a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/landing/Landing.vue
// module id = 91
// module chunks = 0